import React, { useEffect, useRef, useState } from 'react';

const NewProjectModal = ({ artist, onCreate, onClose }) => {
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const inputRef = useRef(null);

    useEffect(() => { inputRef.current?.focus(); }, []);

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    const submit = async (e) => {
        e.preventDefault();
        if (busy) return;
        setBusy(true);
        setError('');
        try {
            await onCreate(name.trim() || 'Untitled');
        } catch (err) {
            setError(err?.message || 'Could not create project.');
            setBusy(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <form className="modal-card new-project-card" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
                <div className="new-project-eyebrow">NEW PROJECT</div>
                <div className="new-project-title">
                    {artist?.name ? `Add to ${artist.name}` : 'Add a project'}
                </div>
                <input
                    ref={inputRef}
                    className="new-project-input"
                    type="text"
                    placeholder="Project name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={busy}
                />
                {error && <div className="new-project-error">{error}</div>}
                <div className="new-project-actions">
                    <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
                    <button type="submit" className="btn-primary" disabled={busy}>
                        {busy ? 'Creating…' : 'Create'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default NewProjectModal;
